// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"Checkbox_checkBoxContainer__LAuMl"};